import { CMJGame } from "./CMJGame";
import { CMJCore } from "./CMJCore";
import { CDefine, CEnumTypes } from "./CEnumTypes";
import { SoundMgr } from "./SoundMgr";
import { sprintf } from 'sprintf-js';
// import { sprintf } from "../typings/sprintf";
import { CGame } from "./CGame";

export class CMJCard {
    private m_MJ:CMJGame;
    private m_mcCur:fgui.GMovieClip = null;
    protected m_Data:number;
    protected m_Enable:number;
    protected m_Last:number;
    protected m_fgGun:number;
    protected m_Status:number;// 吃牌(5, 6, 7), 碰牌(8), 明槓(9), 暗槓(10, 11顯示)
    protected m_Stat:number;
    protected m_Open:number;	// 蓋牌(0), 開牌(1), 
    protected m_Value:number;
    private m_Start:boolean;

    public constructor(mj:CMJGame) {
        this.m_MJ = mj;
        this.Init();
	}

    public Init():void { 
        this.m_Status = 0;	this.m_Enable = 0; 
        this.m_Data = -1; 	this.m_Stat = 0;
        this.m_fgGun = 0;	this.m_Open = 0;
        this.m_Last = 0;	this.m_Value = 0;
        this.m_Start = false;
    }
    private CalcFrame():void {
        var col = 8, row = 5, frame = 0, tframe = 43;

        if( this.m_mcCur ) {
            let mc:fgui.MovieClip = this.m_mcCur.displayObject as fgui.MovieClip;
            tframe = mc.frameCount;
            // if(this.m_mcCur.resourceURL.slice(-1) == "m") tframe = 1;
            // else if(this.m_mcCur.resourceURL.slice(-1) == "k") tframe = 1;
            // else if(this.m_mcCur.resourceURL.slice(-1) == "o") tframe = 1;
            //else if(this.m_mcCur.resourceURL.slice(-1) == "i") tframe = 42;
            if ( this.m_Value == 255 ) {
                if ( this.m_Status == 0 ) {
                    if ( this.m_Last ) this.m_mcCur.frame = 43;
                    else 		       this.m_mcCur.frame = 42;
                }
                return;
            }
        }
        
        if ( this.m_Status && this.m_Status != 10 ) {
            row = ((this.m_Value & 0x70) >> 4);
            col = (this.m_Value & 0x0f);
        }
        if ( row < CDefine.MJTYPE_FLOWERS ) frame = (row - 1) * 9 + col;
        else frame = 3 * 9 + 7 + col;

        // CGame.DebugLog(row, col, frame, tframe, this.m_Status);

        if ( frame >= tframe ) frame = tframe - 1;
        this.m_mcCur.frame = frame;
    }
    public Reset():void {
        if ( this.m_mcCur ) this.m_mcCur.visible = false;
    }
    public SetEnable(v:boolean):void { 
        this.m_mcCur.displayObject.interactive = v;
        // if( v ) this.m_mcCur.displayObject.alpha = 1;
        // else this.m_mcCur.displayObject.alpha = 0.9;
    }
    public GetEnable():boolean { return this.m_mcCur.displayObject.interactive; }
    public GetMC():fgui.GMovieClip { return this.m_mcCur; }
    public IsVisible():boolean { return this.m_mcCur.visible; }
    public SetTrans(tran:number):void {
        this.m_mcCur.alpha = (32.0 - tran) / 32.0;
    }
    public SetData(v:number):void { this.m_Data = v; }
    public GetData():number { return this.m_Data; }
    public SetVS(v:number, name:string):void { 
        this.m_Value = v; this.m_Status = 0; 
        this.m_Stat = 0; this.m_fgGun = 0; this.m_Last = 0;
        this.m_mcCur = this.m_MJ.m_mcLayout.getChild(name) as fgui.GMovieClip;
        this.m_mcCur.playing = false;
        this.m_mcCur.visible = true;
        this.CalcFrame();
    }
    public SetV(v:number, idxOfs:number = -1):void { 
        this.m_Value = v; this.m_Status = 0; 
        this.m_Stat = 0; this.m_fgGun = 0; this.m_Last = 0;
        //CGame.DebugLog(v, idxOfs);
        if ( idxOfs >= 0 ) {
            this.m_mcCur = this.m_MJ.mjCoords[idxOfs] as fgui.GMovieClip;
            this.m_mcCur.playing = false;
            this.m_mcCur.visible = true;
            this.CalcFrame();
            this.m_mcCur.x = this.m_MJ.mjCoords[idxOfs + 1];
            this.m_mcCur.y = this.m_MJ.mjCoords[idxOfs + 2];
            this.m_mcCur.width = this.m_MJ.mjCoords[idxOfs + 3];
            this.m_mcCur.height = this.m_MJ.mjCoords[idxOfs + 4];
        }
    }
    public SetLast():void { this.m_Last = 1; this.CalcFrame(); }
    public SetGun():void { this.m_fgGun = 1; }
    public GetGunFg():number { return this.m_fgGun; }
    public ChgV(v:number):void { this.m_Value = v; this.CalcFrame(); }
    public GetV():number { return this.m_Value; }
    public SetStatus(v:number):void { this.m_Status = v; }
    public GetStatus():number { return this.m_Status; }
    public CheckStat():number { return this.m_Stat; }
    public GetType():number { return CMJCore.GET_MJTYPE(this.m_Value); }
    public GetValue():number { return CMJCore.GET_MJVALUE(this.m_Value); }

    private onTweenStart(snd:number):void {
        if ( snd != -1 ) SoundMgr.play(sprintf("s%03d", snd));
        this.m_Stat = 5;
        //CGame.DebugLog("onTweenStart:", snd);
    }

    private funcComplete(fg:number, idxOfs:number):void {
        if ( fg == 1 ) {
            this.m_Status = 1;
            this.m_mcCur.visible = false;
            this.m_mcCur = this.m_MJ.mjCoords[idxOfs] as fgui.GMovieClip;
            this.m_mcCur.x = this.m_MJ.mjCoords[idxOfs + 1];
            this.m_mcCur.y = this.m_MJ.mjCoords[idxOfs + 2];
            this.m_mcCur.width = this.m_MJ.mjCoords[idxOfs + 3];
            this.m_mcCur.height = this.m_MJ.mjCoords[idxOfs + 4];
            this.CalcFrame();
            this.m_mcCur.visible = true;
        }
        else if ( fg == 2 ) {
            this.m_mcCur.visible = false;
        }
        //this.m_Start = false;
        //CGame.DebugLog("funcComplete:", fg, this.m_mcCur.name);
    }

    public AddMove(idxOfs:number, tmShow:number, tmDelay:number, snd:number = -1, callback:Function = null, v:number = 0):void {
        var mc:fgui.GMovieClip;
        
        if( idxOfs >= 0 ) {
            mc = this.m_MJ.mjCoords[idxOfs] as fgui.GMovieClip;
            mc.x = this.m_MJ.mjCoords[idxOfs + 1];
            mc.y = this.m_MJ.mjCoords[idxOfs + 2];
            mc.width = this.m_MJ.mjCoords[idxOfs + 3];
            mc.height = this.m_MJ.mjCoords[idxOfs + 4];
        }
        else {
            mc = this.m_MJ.mjCoords[ 4-idxOfs] as fgui.GMovieClip;
        }
        //CGame.DebugLog("AddMove:", this.m_mcCur.name);
        this.m_Start = false;
        var that = this;
        createjs.Tween.get(this.m_mcCur, {
            //onChange:this.handleChange.bind(this, snd)})
            onChange:this.handleChange.bind(this, -1)})
            .wait(tmDelay)
            .call(function() {
                if( snd != -1 ) SoundMgr.play(sprintf("s%03d", snd));
            })
            .to({x:mc.x, y:mc.y, width:mc.width, height:mc.height}, tmShow, createjs.Ease.quadOut)
            //.call(this.funcComplete.bind(this, 1, idxOfs));
            .call(function(){
                that.m_Status = 1;
                that.m_mcCur.visible = false;
                that.m_mcCur = that.m_MJ.mjCoords[idxOfs] as fgui.GMovieClip;
                that.m_mcCur.x = that.m_MJ.mjCoords[idxOfs + 1];
                that.m_mcCur.y = that.m_MJ.mjCoords[idxOfs + 2];
                that.m_mcCur.width = that.m_MJ.mjCoords[idxOfs + 3];
                that.m_mcCur.height = that.m_MJ.mjCoords[idxOfs + 4];
                that.CalcFrame();
                that.m_mcCur.visible = true;
                if( callback ) callback(v);
            });
    }

    public AddDisappear(idxOfs:number, tmDelay:number, callback:Function = null):void {
        var mc:fgui.GMovieClip;
        if( idxOfs >= 0 )
            mc = this.m_MJ.mjCoords[idxOfs] as fgui.GMovieClip;
        else 
            mc = this.m_mcCur;

        var that = this;
        createjs.Tween.get(mc)
            .wait(tmDelay)
            .to({x:mc.x, y:mc.y, width:mc.width, height:mc.height }, 100, createjs.Ease.linear)
            .call(function() {
                mc.visible = false;
                //CGame.DebugLog("AddDisappear end:", that.m_mcCur.name);
                if( callback != null ) callback();
            });
    }

    public SetLocation(idxOfs:number, show:boolean = true):void {
        this.m_mcCur.visible = false;
        this.m_mcCur = this.m_MJ.mjCoords[idxOfs] as fgui.GMovieClip;
        this.m_mcCur.x = this.m_MJ.mjCoords[idxOfs + 1];
        this.m_mcCur.y = this.m_MJ.mjCoords[idxOfs + 2];
        this.m_mcCur.width = this.m_MJ.mjCoords[idxOfs + 3];
        this.m_mcCur.height = this.m_MJ.mjCoords[idxOfs + 4];
        this.CalcFrame();
        this.m_mcCur.visible = show;
    }

    public SetLocationV(idxOfs:number, status:number):void {
        this.m_mcCur.visible = false;
        this.m_mcCur = this.m_MJ.mjCoords[idxOfs] as fgui.GMovieClip;
        this.m_mcCur.x = this.m_MJ.mjCoords[idxOfs + 1];
        this.m_mcCur.y = this.m_MJ.mjCoords[idxOfs + 2];
        this.m_mcCur.width = this.m_MJ.mjCoords[idxOfs + 3];
        this.m_mcCur.height = this.m_MJ.mjCoords[idxOfs + 4];
        this.SetStatus(status);
        this.CalcFrame();
        this.m_mcCur.visible = true;
    }

    private endChgLocation(idxOfs:number):void {
        if( this.m_Open ) this.m_Status = 1;
        this.m_mcCur.visible = false;
        this.m_mcCur = this.m_MJ.mjCoords[idxOfs] as fgui.GMovieClip;
        this.m_mcCur.x = this.m_MJ.mjCoords[idxOfs + 1];
        this.m_mcCur.y = this.m_MJ.mjCoords[idxOfs + 2];
        this.m_mcCur.width = this.m_MJ.mjCoords[idxOfs + 3];
        this.m_mcCur.height = this.m_MJ.mjCoords[idxOfs + 4];
        this.CalcFrame();
        this.m_mcCur.visible = true;
        this.m_Stat = 2;
        //CGame.DebugLog("endChgLocation:");
    }

    private endChgLocationN(idxOfs:number):void {
        if( this.m_Open ) this.m_Status = 1;
        this.m_mcCur.visible = false;
        this.m_mcCur = this.m_MJ.mjCoords[idxOfs] as fgui.GMovieClip;
        this.m_mcCur.x = this.m_MJ.mjCoords[idxOfs + 1];
        this.m_mcCur.y = this.m_MJ.mjCoords[idxOfs + 2];
        this.m_mcCur.width = this.m_MJ.mjCoords[idxOfs + 3];
        this.m_mcCur.height = this.m_MJ.mjCoords[idxOfs + 4];
        this.CalcFrame();
        this.m_mcCur.visible = false;
        this.m_Stat = 2;
        //CGame.DebugLog("endChgLocationN:");
    }

    // public ChgLocationN(idxOfs:number, showTm:number = 200, lDelay:number = 0, fgOpen:number = 0, snd:number = -1, callback:Function = null, v:number = 0):number {
    //     this.m_Stat = 0;
    //     this.m_Open = fgOpen;
    //     this.m_Start = false;
    //     //CGame.DebugLog("ChgLocationN:", this.m_mcCur.name);
    //     var that = this;
    //     createjs.Tween.get(this.m_mcCur, {
    //         onChange:this.handleChange.bind(this, snd)})
    //             .wait(lDelay)
    //             .to({x:this.m_MJ.mjCoords[idxOfs + 1], y:this.m_MJ.mjCoords[idxOfs + 2], 
    //                 width:this.m_MJ.mjCoords[idxOfs + 3], height:this.m_MJ.mjCoords[idxOfs + 4]}, showTm, createjs.Ease.linear)
    //             .call(this.endChgLocationN.bind(this, idxOfs))
    //             .wait(showTm + lDelay)
    //             .to({x:this.m_MJ.mjCoords[idxOfs + 1], y:this.m_MJ.mjCoords[idxOfs + 2], 
    //                 width:this.m_MJ.mjCoords[idxOfs + 3], height:this.m_MJ.mjCoords[idxOfs + 4]}, 500, createjs.Ease.linear)
    //             .call(function() {
    //                 //CGame.DebugLog("ChgLocationN2:", that.m_mcCur.name);
    //                 if( callback != null ) callback(v);
    //                 that.m_Stat = 5;
    //                 //that.m_Start = false;
    //             });
    //     return 1;
    // }

    public ChgLocation(idxOfs:number, showTm:number = 200, lDelay:number = 0, fgOpen:number = 0, snd:number = -1, callback:Function = null, v:number = 0):number {
        this.m_Stat = 0;
        this.m_Open = fgOpen;
        // this.endChgLocation(idxOfs);
        // if( callback != null ) callback(v);
        // this.m_Stat = 5;
        //CGame.DebugLog("ChgLocation:", this.m_mcCur.name);
        this.m_Start = false;
        var that = this;
        createjs.Tween.get(this.m_mcCur, {
            onChange:this.handleChange.bind(this, -1)})
                .wait(lDelay)
                .call(function() {
                    if( snd != -1 ) SoundMgr.play(sprintf("s%03d", snd));
                })
                .to({x:this.m_MJ.mjCoords[idxOfs + 1], y:this.m_MJ.mjCoords[idxOfs + 2], 
                    width:this.m_MJ.mjCoords[idxOfs + 3], height:this.m_MJ.mjCoords[idxOfs + 4]}, showTm, createjs.Ease.linear)
                .call(this.endChgLocation.bind(this, idxOfs))
                //.wait(showTm + lDelay)
                // .to({x:this.m_MJ.mjCoords[idxOfs + 1], y:this.m_MJ.mjCoords[idxOfs + 2], 
                //     width:this.m_MJ.mjCoords[idxOfs + 3], height:this.m_MJ.mjCoords[idxOfs + 4]}, 500, createjs.Ease.linear)
                .call(function() {
                    //CGame.DebugLog("ChgLocation2:", that.m_mcCur.name);
                    if( callback != null ) callback(v);
                    that.m_Stat = 5;
                    //that.m_Start = false;
                });
        return 1;
    }

    public ChgLocationImm(idxOfs:number, showTm:number = 200, lDelay:number = 0, fgOpen:number = 0, snd:number = -1, callback:Function = null, v:number = 0):void {
        this.ChgLocation(idxOfs, showTm, lDelay, fgOpen, snd, callback, v);
        // this.m_Stat = 0;
        // this.m_Open = fgOpen;
        // this.endChgLocation(idxOfs);
        // if( callback != null ) callback(v);
        // this.m_Stat = 5;
    }

    private handleChange(snd:number):void {
        if( this.m_Start == false ) {
            this.m_Start = true;
            this.onTweenStart(snd);
        }
    }
}